/* globals lp,Class */
var ImageModule = Class.create(
      lp.ModuleBase,
      lp.ModuleElementMethods,
      lp.ModuleElementBuilderMethods,
      lp.ModuleElementPropertiesPanelMethods,
      {
        javascripts: [
          lp.getPublishedAssetsUrl('published/matchMedia.js'),
          lp.getPublishedAssetsUrl('modules/lp-image/public/main.js')
        ],
        beforeCreate: function (page, defaults, options, asset) {
          defaults.content = {
            asset: {
              company_id: asset.company_id,
              uuid: asset.uuid,
              unique_url: asset.unique_url,
              content_url: asset.content_url,
              content_content_type: asset.content_content_type,
              name: asset.name
            },
            target: page.getConfigValue('linkTargetDefault')
          };

          if (page.allowExternalLightboxes()) {
            defaults.lightboxSize = lp.module.image.ImageElement.lightboxSizeDefault;
          }
        },

        insertElement: function (element, options) {
          if(!options.hideLoader){
            window.editor.wait();
          }
          element.img.observe('load', element.createImageObserver(
            options.center,
            options.autoscale,
            options.hideLoader
          ));
        },

        openElementBuilder: function(elm, options) {
          options.onChoose = options.callback;
          options.onlyImages = true;
          window.editor.openAssetChooser(options);
        }
      }
  );

lp.addModule(new ImageModule({
    type:'lp-pom-image',
    isAllowedOnPage: function(page) {
      return page.getConfigValue('allowImageWidget');
    },
    version:'1.0',
    name: 'Image',
    usageType:'page-widget',
    namespace: lp.module.image
  }));

module.exports = ImageModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-image/image_module.js
// module id = 550
// module chunks = 0 1